<template>
	<a-card class="BlackListSet">
		<a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol">
            <a-form-model-item label="标题" prop="title">
				<a-input placeholder="请输入标题" allow-clear :maxLength="20" v-model="form.title"/>
			</a-form-model-item>
            <a-form-model-item label="对象类型" prop="type">
				<a-select
					allowClear
                    @change="changeSelect"
					v-model="form.type"
					placeholder="请选择对象类型"
					style="width:198px;">
					<a-select-option :value="1">机构</a-select-option>
					<a-select-option :value="2">课程</a-select-option>
				</a-select>
			</a-form-model-item>
            <a-form-model-item label="选择机构" prop="rule" v-if="form.type == 1">
				<a-select
                    :filter-option="filterOption"
                    mode="multiple"
					allowClear
					v-model="form.rule"
					placeholder="请选择机构"
					style="min-width:198px;">
					<a-select-option :value="item.id" v-for="item in organizationList">{{ item.name }}</a-select-option>
				</a-select>
			</a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 2 }" v-if="form.type == 2">
                <a-button type="primary" @click="selectCourse">选择</a-button>
                <div class="list">
                    <span @click.stop="deleteGame(item,index)" v-for="(item,index) in course.list" :key="index">
                        {{ item.name || item}}
                        <em><a-icon type="close" /></em>
                    </span>
                </div>
            </a-form-model-item>
        </a-form-model>
        <footer-tool-bar>
            <div class="btns">
                <a-button @click="backpage()" style="margin-right: 15px;">返回</a-button>
                <a-button type="primary" @click="onSubmit">
                    保存
                </a-button>
            </div>
        </footer-tool-bar>
        <a-modal v-model="course.visible" title="选择训练" @ok="handleOk" @cancel="handleCancel" width="1200px">
            <a-form-model layout="inline" style="margin-top:15px;">
                <a-form-model-item label="机构名称">
                    <a-select
                        :filter-option="filterOption"
                        mode="multiple"
                        allowClear
                        v-model="course.search.organizationId"
                        placeholder="请选择机构"
                        style="min-width:198px;">
                        <a-select-option :value="item.id" v-for="item in organizationList">{{ item.name }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="训练名称">
                    <a-input placeholder="请输入训练名称" allow-clear :maxLength="20" v-model="course.search.courseName" @keyup.enter="getCourseList(1)"/>
                </a-form-model-item>
                <a-form-model-item label="资源名称">
                    <a-input placeholder="请输入资源名称" allow-clear :maxLength="20" v-model="course.search.resourceName" @keyup.enter="getCourseList(1)"/>
                </a-form-model-item>

                <a-form-model-item>
                    <a-button type="primary" @click="getCourseList(1)">查询</a-button>
                </a-form-model-item>
            </a-form-model>
            <div class="table">
                <a-table
                    :columns="course.columns"
                    :scroll="{y: 350}"
                    :row-selection="rowSelection"
                    rowKey="id"
                    @change="handleTableChange"
                    :pagination="course.tableRelevant.tablePagination"
                    :loading="course.tableRelevant.tableLoading"
                    :dataSource="course.tableRelevant.tableDataSource">
                    <div slot="progress" slot-scope="text">
                        <a-progress :percent="text.progress"/>
                    </div>
                </a-table>
            </div>
        </a-modal>
	</a-card>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus"
import FooterToolBar from "@/components/tool/FooterToolBar";
import {tableRelevant} from "@/pages/projectImpl/js/utils";
const columns = [
	{title: '机构名称',dataIndex: 'organizationName'},
	{title: '训练名称',dataIndex: 'name'},
	{title: '资源名称',dataIndex: 'courseResourceName'},
	{title: '学生数',dataIndex: 'courseResourceConfigUserCount'},
	{title: '课程进度',scopedSlots: { customRender: 'progress' }},
	{title: '状态',dataIndex: 'statusName'},
	{title: '创建时间',dataIndex: 'createTime'}
]

export default {
	name:'BlackListSet',
    components: {FooterToolBar},
	data() {
		return {
			labelCol: { span: 2 },
            wrapperCol: { span: 14 },
            organizationList:[],

			form:{
                title:undefined,
                type:undefined,
                rule:[]
            },
            rules: {
                title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                type: [{ required: true, message: '请选择对象类型', trigger: 'blur' }],
                rule: [{ required: true, message: '请选择机构', trigger: 'blur' }],
            },

            course:{
                visible:false,
                search:{
                    organizationId:undefined,
                    name:undefined,
                    resourceName:undefined,
                },
                columns,
			    tableRelevant: tableRelevant.call(this,this.getCourseList),
                selectedRowKeys:[],
                list:[]
            },
            info:{},
            allCourse:[]
		}
	},
	mounted(){
		this.setTitle()
        this.getAllOrg()
        this.getCourseList(1)
        this.getAllcourse(false)
        // 回显
        if(this.$route.query.type == 'edit'){
            this.getAllcourse(true)
            this.info = JSON.parse(localStorage.getItem('BlackText'))
            this.form = {
                title:this.info.title,
                type:+this.info.type,
                rule:[]
            }
            if(this.info.type == 1){
                this.form.rule = this.info.rule
            }
        }
	},
    computed: {
        rowSelection() {
            return {
                selectedRowKeys: this.course.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.course.selectedRowKeys = selectedRowKeys;
                },
            };
        }
    },
	methods:{
        backpage(){
            this.$router.push('/content/GamesComment?activekey=3')
        },
        changeSelect(value){
            this.form.rule = []
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
		setTitle() {
            let tabName = this.$route.query.type == 'add' ? '添加' : '编辑'
			const arr = ["首页", "内容中心", {name: "游戏评价", path:'/content/GamesComment'}, {name: "黑名单", path:'/content/GamesComment?activekey=3'}, tabName];
			$Bus.$emit("pageHeaderBreadcrumb", arr);
			$Bus.$emit("pageHeaderTitle", tabName);
			$Bus.$emit("updateTabName", {path: this.$route.path, name: tabName + '黑名单'});
      	},
        // 获取机构列表
        getAllOrg(){
            let params = {
                type:0
            }
            this.$http.loadAllByType(params)
            .then(res =>{
                    this.organizationList = res.data.data;
            })
        },
        getAllcourse(bool){
            let params = {
                pageIndex:1,
                pageSize:99999,
                courseType:2,
                enabled:true,
                ...this.course.search
            }
            this.$http.GamesComment.getCourseConfigList(params)
            .then( res =>{
                const { status, data, message } = res;
                    this.allCourse = data.items
                    if(this.info.type == 2 && bool){
                        this.course.list = this.info.keys
                        this.info.rule.forEach(v =>{
                            this.course.selectedRowKeys.push(+v)
                        })
                        // 回显参数赋值
                        this.form.rule = this.info.ids
                    }

            })
        },
        getCourseList(pageIndex){
            let params = {
                pageIndex:pageIndex || this.course.tableRelevant.tablePagination.current,
                pageSize:this.course.tableRelevant.tablePagination.pageSize,
                courseType:2,
                enabled:true,
                ...this.course.search
            }
            this.course.tableRelevant.tableLoading = true
            this.$http.GamesComment.getCourseConfigList(params)
            .then(res =>{
                const { status, data, message } = res;
                    this.course.tableRelevant.tableDataSource = data.items;
                    this.course.tableRelevant.tablePagination.total = data.totalCount;
                    this.course.tableRelevant.tablePagination.current = data.pageIndex;
                
            }).finally(() => {
              this.course.tableRelevant.tableLoading = false
            })
        },
        selectCourse(){
            this.course.visible = true
            this.getCourseList(1)
        },
        handleOk(){
            this.form.rule = []
            this.course.list =  []
            // this.course.list = this.course.selectedRowKeys.map(v =>{
            //     return JSON.parse(v)
            // })
            this.allCourse.forEach(v =>{
                this.course.selectedRowKeys.forEach( m=>{
                    if(v.id == m){
                        this.course.list.push(v)
                    }
                })
            })
            this.course.list.forEach(v =>{
                this.form.rule.push(v.id)
            })
            this.handleCancel()
        },
        // 删除选中
        deleteGame(item,index){
            this.course.list.splice(index, 1);
            this.course.selectedRowKeys.forEach((v,i) =>{
                if(this.form.rule[index] == v){
                    this.course.selectedRowKeys.splice(i, 1)
                }
            })
            this.form.rule.splice(index, 1);
        },
        handleCancel(){
            this.course.visible = false
            this.course.search = {
                organizationId:undefined,
                name:undefined,
                resourceName:undefined,
            }
        },
        handleTableChange(){

        },
        onSubmit(){
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(this.form.rule);
                    if(!this.form.rule.length){
                        this.$message.destroy();
                        this.$message.warning('请选择课程')
                        return
                    }
                    if(this.$route.query.type == 'edit' || this.info.id){
                        this.edit()
                    }else{
                        this.add()
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        edit(){
            this.form.id = this.info.id
            let params = {
                ...this.form
            }
            this.$http.GamesComment.editBlacklist(params)
            .then(res =>{
                const {status, data, message} = res;
					this.$message.success('操作成功');
				
            })
        },
        add(){
            let params = {
                ...this.form
            }
            this.$http.GamesComment.addBlacklist(params)
            .then(res =>{
                const {status, data, message} = res;
                    this.info.id = data
					this.$message.success('操作成功');
				
            })
        }
	}
}
</script>

<style lang="less" scoped>
.table{
	margin-top: 15px;
}
.list{
    display: inline-block;
    margin-top: 15px;
    padding: 0 15px;
    span{
        padding: 5px 10px;
        border: 1px solid rgb(217, 217, 217);
        border-radius: 4px;
        cursor: pointer;
        display: inline-block;
        height: 32px;
        line-height: 20px;
        margin-right: 15px;
        margin-bottom: 5px;

        em{
            font-style: normal;
            margin-left: 10px;

        }
    }
}
</style>
